(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["mars-cart-drawer"] && !Shopify.designMode) return;
  try {
    (function () {
    var root = document.querySelector('[data-mcart]');
    if (!root) return;
    var itemsEl = root.querySelector('[data-mcart-items]');
    var emptyEl = root.querySelector('[data-mcart-empty]');
    var subEl = root.querySelector('[data-mcart-subtotal]');
    var discEl = root.querySelector('[data-mcart-discount]');
    var totEl = root.querySelector('[data-mcart-total]');
    var barFill = root.querySelector('[data-mcart-barfill]');
    var shipMsg = root.querySelector('[data-mcart-shipmsg]');
    var COMPARE = window.MCART_COMPARE || {};
    var THRESHOLD = window.MCART_THRESHOLD || 0;
    var GIFT_IDS = (window.MCART_GIFT_IDS || []).map(Number);
    var GIFT_SET = {}; GIFT_IDS.forEach(function (id) { GIFT_SET[id] = true; });
    var TAG_SVG = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M20.6 13.4l-7.2 7.2a2 2 0 0 1-2.8 0l-7.2-7.2a2 2 0 0 1-.6-1.4V4a2 2 0 0 1 2-2h8a2 2 0 0 1 1.4.6l6.4 6.4a2 2 0 0 1 0 2.8z"/><circle cx="7.5" cy="7.5" r="1.2" fill="currentColor"/></svg>';

    function money(c) { return '$' + (c / 100).toFixed(2); }
    function esc(s) { var d = document.createElement('div'); d.textContent = s == null ? '' : s; return d.innerHTML; }

    function lock(on) { document.body.style.overflow = on ? 'hidden' : ''; }
    function open() { root.hidden = false; requestAnimationFrame(function () { root.classList.add('is-open'); }); lock(true); refresh(); }
    function close() { root.classList.remove('is-open'); lock(false); setTimeout(function () { root.hidden = true; }, 320); }

    function updateCounts(n) { document.querySelectorAll('[data-cart-count]').forEach(function (el) { el.textContent = n; if (el.hasAttribute('hidden') && n > 0) el.removeAttribute('hidden'); }); }

    function qIcon(n) { return (window.__mcartIcons && window.__mcartIcons[n]) || ''; }

    function lineHTML(it, line) {
      var isGift = !!GIFT_SET[it.variant_id];
      var img = it.image ? it.image.replace(/(\.[a-z]+)(\?|$)/i, '_160x160$1$2') : '';
      var sub = (it.variant_title && it.variant_title !== 'Default Title') ? '<p class="mcart__sub">' + esc(it.variant_title) + '</p>' : '';

      // line-level automatic-discount info (e.g. the Buy-X-Get-Y "free gift")
      var allocs = it.line_level_discount_allocations || [];
      var lineDisc = 0, discTitle = '';
      allocs.forEach(function (a) { lineDisc += a.amount; if (!discTitle && a.discount_application) discTitle = a.discount_application.title; });

      var cmp = COMPARE[it.variant_id];
      var retailUnit = (cmp && cmp > it.original_price) ? cmp : it.original_price; // pre-discount unit price to strike
      var finalUnit = it.final_price;

      var priceHTML, meta, qty, trash;
      if (isGift) {
        var freeLabel = finalUnit === 0 ? 'FREE' : money(finalUnit);
        priceHTML = '<div class="mcart__price mcart__price--gift">' +
          (retailUnit > finalUnit ? '<s>' + money(retailUnit) + '</s>' : '') +
          '<span class="now">' + freeLabel + '</span></div>';
        meta = (lineDisc > 0)
          ? '<p class="mcart__gifttag">' + TAG_SVG + '<span>' + esc(discTitle || 'Free gift') + ' (-' + money(lineDisc) + ')</span></p>'
          : '';
        qty = '<div class="mcart__qty"><button class="mcart__qbtn" disabled>' + qIcon('minus') + '</button><span class="mcart__qnum">' + it.quantity + '</span><button class="mcart__qbtn" disabled>' + qIcon('plus') + '</button></div>';
        trash = '<button class="mcart__trash" disabled>' + qIcon('trash') + '</button>';
      } else {
        priceHTML = '<div class="mcart__price"><span class="now">' + money(finalUnit) + '</span>' + (retailUnit > finalUnit ? '<s>' + money(retailUnit) + '</s>' : '') + '</div>';
        meta = it.selling_plan_allocation ? '<p class="mcart__every">Delivered every <b>30 days</b></p>' : '';
        qty = '<div class="mcart__qty">' +
          '<button class="mcart__qbtn" data-mqty="dec" data-line="' + line + '" aria-label="Decrease">' + qIcon('minus') + '</button>' +
          '<span class="mcart__qnum">' + it.quantity + '</span>' +
          '<button class="mcart__qbtn" data-mqty="inc" data-line="' + line + '" aria-label="Increase">' + qIcon('plus') + '</button></div>';
        trash = '<button class="mcart__trash" data-mremove="' + line + '" aria-label="Remove">' + qIcon('trash') + '</button>';
      }

      return '<div class="mcart__item' + (isGift ? ' mcart__item--gift' : '') + '" data-line="' + line + '">' +
        '<img class="mcart__thumb" src="' + img + '" alt="" loading="lazy">' +
        '<div class="mcart__info"><p class="mcart__name">' + esc(it.product_title) + '</p>' + sub + meta + priceHTML + qty + '</div>' +
        trash + '</div>';
    }

    function render(cart) {
      updateCounts(cart.item_count);
      var subtotal = 0;
      var html = cart.items.map(function (it, i) {
        var cmp = COMPARE[it.variant_id];
        var retailLine = (cmp && cmp > it.original_price) ? cmp * it.quantity : it.original_line_price;
        subtotal += retailLine;
        return lineHTML(it, i + 1);
      }).join('');

      emptyEl.hidden = cart.item_count > 0;
      itemsEl.innerHTML = html;

      var total = cart.total_price;
      var discount = Math.max(0, subtotal - total);
      subEl.textContent = money(subtotal);
      discEl.textContent = (discount > 0 ? '-' : '') + money(discount);
      totEl.textContent = money(total);

      var pct = THRESHOLD <= 0 ? 100 : Math.min(100, (total / THRESHOLD) * 100);
      barFill.style.width = pct + '%';
      shipMsg.textContent = pct >= 100 ? 'You Unlocked Free Shipping + Gifts!' : 'Spend ' + money(THRESHOLD - total) + ' more for Free Shipping';
    }

    // Reconcile gifts: if no main product remains, drop the free gifts (so they can't be kept free alone).
    function handleCart(cart) {
      var hasMain = cart.items.some(function (it) { return !GIFT_SET[it.variant_id]; });
      var giftLines = cart.items.filter(function (it) { return GIFT_SET[it.variant_id]; });
      if (!hasMain && giftLines.length) {
        var updates = {};
        giftLines.forEach(function (it) { updates[it.variant_id] = 0; });
        return fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ updates: updates }) })
          .then(function (r) { return r.json(); }).then(render);
      }
      render(cart);
    }

    function refresh() { fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); }).then(handleCart); }
    function change(line, qty) { fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ line: line, quantity: qty }) }).then(function (r) { return r.json(); }).then(handleCart); }

    // Add the main product (with its selling plan) plus any free gifts not already in the cart.
    function addToCart(form) {
      var btn = form.querySelector('[type="submit"]');
      if (btn) btn.disabled = true;
      return fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); }).then(function (cart) {
        var present = {}; cart.items.forEach(function (it) { present[it.variant_id] = true; });
        var fd = new FormData(form);
        var main = { id: Number(fd.get('id')), quantity: parseInt(fd.get('quantity') || '1', 10) || 1 };
        var sp = fd.get('selling_plan'); if (sp) main.selling_plan = Number(sp);
        var items = [main];
        GIFT_IDS.forEach(function (gid) { if (!present[gid]) items.push({ id: gid, quantity: 1 }); });
        return fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: items }) }).then(function (r) { return r.json(); });
      }).then(function () { if (btn) btn.disabled = false; open(); }).catch(function () { if (btn) btn.disabled = false; form.submit(); });
    }

    // capture the inline icon SVGs once (cloned from the static markup so JS rows reuse them)
    window.__mcartIcons = {
      minus: (root.querySelector('[data-mcart-close]') ? '' : ''),
    };
    // pull icon markup from hidden templates rendered below
    var tplWrap = document.getElementById('mcart-icon-tpls');
    if (tplWrap) {
      window.__mcartIcons = {
        minus: tplWrap.querySelector('[data-i="minus"]').innerHTML,
        plus: tplWrap.querySelector('[data-i="plus"]').innerHTML,
        trash: tplWrap.querySelector('[data-i="trash"]').innerHTML
      };
      window.__mcartGiftIcon = tplWrap.querySelector('[data-i="gift"]').innerHTML;
    }

    // events
    root.addEventListener('click', function (e) {
      if (e.target.closest('[data-mcart-close]')) { close(); return; }
      var inc = e.target.closest('[data-mqty="inc"]');
      var dec = e.target.closest('[data-mqty="dec"]');
      var rem = e.target.closest('[data-mremove]');
      if (inc) { var l = +inc.dataset.line; var n = +inc.parentNode.querySelector('.mcart__qnum').textContent; change(l, n + 1); }
      else if (dec) { var l2 = +dec.dataset.line; var n2 = +dec.parentNode.querySelector('.mcart__qnum').textContent; change(l2, Math.max(0, n2 - 1)); }
      else if (rem) { change(+rem.dataset.mremove, 0); }
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && root.classList.contains('is-open')) close(); });

    // open from any cart trigger (header cart icon)
    document.querySelectorAll('[data-mcart-open]').forEach(function (el) {
      el.addEventListener('click', function (e) { e.preventDefault(); open(); });
    });

    // TRY IT NOW: intercept the product form, add main + gifts via AJAX, then open
    document.querySelectorAll('.mars-bb__form').forEach(function (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        addToCart(form);
      });
    });

    root._mcartOpen = open;
  })();
  } catch(e) { console.error(e); }
})();

})();
